//import { Notification } from "element-ui";
import { api } from "../../gateways/unilabApi";

export default {
  getUserCustomers() {
    return new Promise((resolve, reject) => {
      api
        .get("offerte/listaclientiproprietario")
        .then(response => {
          if (!response.isAxiosError) {
            resolve(response.data);
          } else {
            console.log(response.response);
            //Notification.warning({
            //  title: "Error",
            // message: response.response !== undefined ? response.response.data : "No Response"
            //});
            reject(response);
          }
        })
        .catch(error => {
          console.log(error);
          //Notification.warning({
          //  title: "Error",
          //  message: error
          //});
          reject(error);
        });
    });
  },
  getAllUserCustomers() {
    return new Promise((resolve, reject) => {
      api
        .get("offerte/listaclienti")
        .then(response => {
          if (!response.isAxiosError) {
            resolve(response.data);
          } else {
            console.log(response.response);
            //Notification.warning({
            //  title: "Error",
            //  message: response.response !== undefined ? response.response.data : "No Response"
            //});
            reject(response);
          }
        })
        .catch(error => {
          console.log(error);
          //Notification.warning({
          //  title: "Error",
          //  message: error
          //});
          reject(error);
        });
    });
  },
  exportUserCustomersToExcel() {
    return new Promise((resolve, reject) => {
      api
        .get("offerte/listaclientiproprietarioexcel")
        .then(response => {
          if (!response.isAxiosError) {
            resolve(response.data);
          } else {
            console.log(response.response);
            //Notification.warning({
            //  title: "Error",
            //  message: response.response !== undefined ? response.response.data : "No Response"
            //});
            reject(response);
          }
        })
        .catch(error => {
          console.log(error);
          //Notification.warning({
          //  title: "Error",
          //  message: error
          //});
          reject(error);
        });
    });
  },
  deleteCustomer(id) {
    return new Promise((resolve, reject) => {
      //alert("pippo =>" + id);
      api
        .delete("offerte/cancellacliente", { params: { IdCliente: id } })
        .then(response => {
          if (!response.isAxiosError) {
            resolve(response.data);
          } else {
            console.log(response.response);
            //Notification.warning({
            //  title: "Error",
            //  message: response.response !== undefined ? response.response.data : "No Response"
            //});
            reject(response);
          }
        })
        .catch(error => {
          console.log(error);
          //Notification.warning({
          //  title: "Error",
          //  message: error
          //});
          reject(error);
        });
    });
  },
  getCustomer(id) {
    return new Promise((resolve, reject) => {
      api
        .get("offerte/caricacliente", { params: { IdCliente: id } })
        .then(response => {
          if (!response.isAxiosError) {
            resolve(response.data);
          } else {
            console.log(response.response);
            //Notification.warning({
            //  title: "Error",
            //  message: response.response !== undefined ? response.response.data : "No Response"
            //});
            reject(response);
          }
        })
        .catch(error => {
          console.log(error);
          //Notification.warning({
          //  title: "Error",
          //  message: error
          //});
          reject(error);
        });
    });
  },
  updateCustomer(Cliente) {
    return new Promise((resolve, reject) => {
      api
        .put("offerte/aggiornacliente", Cliente)
        .then(response => {
          if (!response.isAxiosError) {
            resolve(response.data);
          } else {
            console.log(response.response);
            //Notification.warning({
            //  title: "Error",
            //  message: response.response !== undefined ? response.response.data : "No Response"
            //});
            reject(response);
          }
        })
        .catch(error => {
          console.log(error);
          //Notification.warning({
          //  title: "Error",
          //  message: error
          //});
          reject(error);
        });
    });
  },
  saveProjectOnOffer(dto) {
    return new Promise((resolve, reject) => {
      api
        .put("offerte/saveprojectonoffer", dto)
        .then(response => {
          if (!response.isAxiosError) {
            resolve(response.data);
          } else {
            console.log(response.response);
            //Notification.warning({
            // title: "Error",
            //  message: response.response !== undefined ? response.response.data : "No Response"
            //});
            reject(response);
          }
        })
        .catch(error => {
          console.log(error);
          //Notification.warning({
          //  title: "Error",
          //  message: error
          //});
          reject(error);
        });
    });
  },
  newCustomer() {
    return new Promise((resolve, reject) => {
      api
        .post("offerte/nuovocliente")
        .then(response => {
          if (!response.isAxiosError) {
            resolve(response.data);
          } else {
            console.log(response.response);
            //Notification.warning({
            //  title: "Error",
            //  message: response.response !== undefined ? response.response.data : "No Response"
            //});
            reject(response);
          }
        })
        .catch(error => {
          console.log(error);
          //Notification.warning({
          //  title: "Error",
          //  message: error
          //});
          reject(error);
        });
    });
  },
  getUserOffers() {
    return new Promise((resolve, reject) => {
      api
        .get("offerte/listaofferte") /* listaofferteproprietario */
        .then(response => {
          if (!response.isAxiosError) {
            resolve(response.data);
          } else {
            console.log(response.response);
            //Notification.warning({
            //  title: "Error",
            //  message: response.response !== undefined ? response.response.data : "No Response"
            //});
            reject(response);
          }
        })
        .catch(error => {
          console.log(error);
          //Notification.warning({
          //  title: "Error",
          //  message: error
          //});
          reject(error);
        });
    });
  },
  duplicateOffer(id) {
    return new Promise((resolve, reject) => {
      //alert("pippo =>" + id);
      api
        .delete("offerte/duplicafferta", { params: { IdOfferta: id } })
        .then(response => {
          if (!response.isAxiosError) {
            resolve(response.data);
          } else {
            console.log(response.response);
            //Notification.warning({
            //  title: "Error",
            //  message: response.response !== undefined ? response.response.data : "No Response"
            //});
            reject(response);
          }
        })
        .catch(error => {
          console.log(error);
          //Notification.warning({
          //  title: "Error",
          //  message: error
          //});
          reject(error);
        });
    });
  },
  deleteOffer(id) {
    return new Promise((resolve, reject) => {
      //alert("pippo =>" + id);
      api
        .delete("offerte/cancellaofferta", { params: { IdOfferta: id } })
        .then(response => {
          if (!response.isAxiosError) {
            resolve(response.data);
          } else {
            console.log(response.response);
            //Notification.warning({
            //  title: "Error",
            //  message: response.response !== undefined ? response.response.data : "No Response"
            //});
            reject(response);
          }
        })
        .catch(error => {
          console.log(error);
          //Notification.warning({
          //  title: "Error",
          //  message: error
          //});
          reject(error);
        });
    });
  },
  getOffer(id) {
    return new Promise((resolve, reject) => {
      api
        .get("offerte/caricaofferta", { params: { IdOfferta: id } })
        .then(response => {
          if (!response.isAxiosError) {
            resolve(response.data);
          } else {
            console.log(response.response);
            //Notification.warning({
            //  title: "Error",
            //  message: response.response !== undefined ? response.response.data : "No Response"
            //});
            reject(response);
          }
        })
        .catch(error => {
          console.log(error);
          //Notification.warning({
          // title: "Error",
          //  message: error
          //});
          reject(error);
        });
    });
  },
  updateOffer(Offerta) {
    return new Promise((resolve, reject) => {
      api
        .put("offerte/aggiornaofferta", Offerta)
        .then(response => {
          if (!response.isAxiosError) {
            resolve(response.data);
          } else {
            console.log(response.response);
            //Notification.warning({
            //  title: "Error",
            //  message: response.response !== undefined ? response.response.data : "No Response"
            //});
            reject(response);
          }
        })
        .catch(error => {
          console.log(error);
          //Notification.warning({
          //  title: "Error",
          //  message: error
          //});
          reject(error);
        });
    });
  },
  deleteOfferRow(id) {
    return new Promise((resolve, reject) => {
      //alert("pippo =>" + id);
      api
        .delete("offerte/cancellaoffertariga", { params: { IdOffertaRiga: id } })
        .then(response => {
          if (!response.isAxiosError) {
            resolve(response.data);
          } else {
            console.log(response.response);
            //Notification.warning({
            //  title: "Error",
            //  message: response.response !== undefined ? response.response.data : "No Response"
            //});
            reject(response);
          }
        })
        .catch(error => {
          console.log(error);
          //Notification.warning({
          //  title: "Error",
          //  message: error
          //});
          reject(error);
        });
    });
  },
  updateOfferRow(rigaOfferta) {
    return new Promise((resolve, reject) => {
      api
        .put("offerte/aggiornaoffertariga", rigaOfferta)
        .then(response => {
          if (!response.isAxiosError) {
            resolve(response.data);
          } else {
            console.log(response.response);
            //Notification.warning({
            //  title: "Error",
            //  message: response.response !== undefined ? response.response.data : "No Response"
            //});
            reject(response);
          }
        })
        .catch(error => {
          console.log(error);
          //Notification.warning({
          // title: "Error",
          //  message: error
          //});
          reject(error);
        });
    });
  },
  //================================================
  //MARCO DC 09/06/2021
  updateOfferRows(righeOfferta) {
    return new Promise((resolve, reject) => {
      api
        .put("offerte/aggiornaoffertarighe", righeOfferta)
        .then(response => {
          if (!response.isAxiosError) {
            resolve(response.data);
          } else {
            console.log(response.response);
            //Notification.warning({
            //  title: "Error",
            //  message: response.response !== undefined ? response.response.data : "No Response"
            //});
            reject(response);
          }
        })
        .catch(error => {
          console.log(error);
          //Notification.warning({
          // title: "Error",
          //  message: error
          //});
          reject(error);
        });
    });
  },
  //================================================
  addOfferRow(idOff, prjFront) {

    prjFront.idOfferta = idOff;
    return new Promise((resolve, reject) => {
      api
        .post("offerte/aggiungirigaofferta", prjFront)
        .then(response => {
          if (!response.isAxiosError) {
            resolve(response.data);
          } else {
            console.log(response.response);
            //Notification.warning({
            // title: "Error",
            //  message: response.response !== undefined ? response.response.data : "No Response"
            //});
            reject(response);
          }
        })
        .catch(error => {
          console.log(error);
          //Notification.warning({
          //  title: "Error",
          //  message: error
          //});
          reject(error);
        });
    });
  },
  replaceOfferRow(prj) {
    return new Promise((resolve, reject) => {
      api
        .post("offerte/sostituiscirigaofferta", prj)
        .then(response => {
          if (!response.isAxiosError) {
            resolve(response.data);
          } else {
            console.log(response.response);
            //Notification.warning({
            //  title: "Error",
            //  message: response.response !== undefined ? response.response.data : "No Response"
            //});
            reject(response);
          }
        })
        .catch(error => {
          console.log(error);
          //Notification.warning({
          //  title: "Error",
          //  message: error
          //});
          reject(error);
        });
    });
  }
};
